<div class="project-single">

    <div class="project-single-media m-b30">
        <img src="{{data.cover}}" alt="">
    </div>

    <div class="wt-info bg-white" [innerHTML]="data.description">
    </div>
</div>